// extracted by mini-css-extract-plugin
module.exports = {"input":"_3121591","root":"_01d99b1","label":"_c41ccd6"};